import { render, staticRenderFns } from "./PostalCodes.vue?vue&type=template&id=341ff356&scoped=true&"
import script from "./PostalCodes.vue?vue&type=script&lang=js&"
export * from "./PostalCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341ff356",
  null
  
)

export default component.exports